export enum BillingServiceLevelEnum {
    STANDARD = 1,
    PRIORITY,
}

export const BillingServiceLevelText: { [key in BillingServiceLevelEnum]: string } = {
    [BillingServiceLevelEnum.STANDARD]: '72 Hours (Standard)',
    [BillingServiceLevelEnum.PRIORITY]: '24 Hours (Priority)',
};
